export default __webpack_public_path__ + "static/doublure.inspirations-87026297be86deec3f61faf87dae3001.jpg";